import React from 'react';
import './LegalPages.css';

const PolitiqueConfidentialite = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Politique de confidentialité</h1>
        
        <section>
          <h2>Introduction</h2>
          <p>
            La présente politique de confidentialité décrit comment SoundNest traite 
            les informations lors de votre utilisation de notre site web. Nous nous 
            engageons à protéger votre vie privée et à être transparents sur nos pratiques.
          </p>
        </section>

        <section>
          <h2>Données personnelles collectées</h2>
          <h3>Aucune collecte de données personnelles</h3>
          <p>
            <strong>SoundNest ne collecte aucune donnée personnelle.</strong> Nous ne demandons 
            pas d'inscription, ne stockons pas d'adresses email, et ne conservons aucune 
            information permettant de vous identifier personnellement.
          </p>
          
          <h3>Données stockées localement</h3>
          <p>
            Les seules données liées à votre utilisation sont :
          </p>
          <ul>
            <li><strong>Favoris :</strong> La liste de vos sons favoris est stockée dans le localStorage de votre navigateur</li>
            <li><strong>Préférences :</strong> Vos préférences d'interface (mode sombre, etc.) sont stockées localement</li>
            <li><strong>Historique de recherche :</strong> Vos recherches récentes sont stockées temporairement dans votre navigateur</li>
          </ul>
          <p>
            <em>Ces données ne quittent jamais votre appareil et ne sont jamais transmises à nos serveurs.</em>
          </p>
        </section>

        <section>
          <h2>Streaming audio et contenus externes</h2>
          <h3>LaSonotheque.org</h3>
          <p>
            Tous les sons disponibles sur SoundNest sont hébergés par <strong>LaSonotheque.org</strong>. 
            Lorsque vous écoutez un son ou le téléchargez :
          </p>
          <ul>
            <li>Votre navigateur se connecte directement aux serveurs de LaSonotheque.org</li>
            <li>Votre adresse IP peut être visible par leurs serveurs</li>
            <li>SoundNest ne reçoit aucune information sur cette interaction</li>
          </ul>
          <p>
            Nous vous invitons à consulter la politique de confidentialité de LaSonotheque.org 
            pour comprendre comment ils traitent ces données.
          </p>
        </section>

        <section>
          <h2>Cookies et technologies de suivi</h2>
          <h3>Cookies publicitaires (Google AdSense)</h3>
          <p>
            Ce site utilise <strong>Google AdSense</strong> pour afficher des publicités. 
            Google peut utiliser des cookies pour :
          </p>
          <ul>
            <li>Personnaliser les publicités en fonction de vos centres d'intérêt</li>
            <li>Mesurer l'efficacité des publicités</li>
            <li>Éviter de vous montrer des publicités que vous avez déjà vues</li>
          </ul>
          
          <h3>Gestion des cookies</h3>
          <p>
            Vous pouvez contrôler l'utilisation des cookies publicitaires :
          </p>
          <ul>
            <li>Via les paramètres de votre navigateur</li>
            <li>Via les <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">paramètres publicitaires de Google</a></li>
            <li>En utilisant des extensions de blocage de publicités</li>
          </ul>
        </section>

        <section>
          <h2>Conformité RGPD</h2>
          <p>
            Bien que nous ne collections aucune donnée personnelle, nous respectons 
            les principes du Règlement Général sur la Protection des Données (RGPD) :
          </p>
          <ul>
            <li><strong>Minimisation des données :</strong> Nous ne collectons aucune donnée non nécessaire</li>
            <li><strong>Transparence :</strong> Cette politique explique clairement nos pratiques</li>
            <li><strong>Contrôle utilisateur :</strong> Vos données locales peuvent être supprimées à tout moment</li>
            <li><strong>Sécurité :</strong> Aucune donnée personnelle n'est transmise ou stockée sur nos serveurs</li>
          </ul>
        </section>

        <section>
          <h2>Vos droits</h2>
          <h3>Suppression des données locales</h3>
          <p>
            Vous pouvez à tout moment supprimer toutes les données stockées localement :
          </p>
          <ul>
            <li>En vidant le cache et les données de votre navigateur pour ce site</li>
            <li>En utilisant la navigation privée/incognito</li>
            <li>En supprimant manuellement vos favoris depuis l'interface</li>
          </ul>
          
          <h3>Cookies publicitaires</h3>
          <p>
            Pour les cookies publicitaires, vous disposez des droits suivants :
          </p>
          <ul>
            <li>Droit d'opposition au traitement à des fins publicitaires</li>
            <li>Droit de retrait du consentement</li>
            <li>Droit d'accès aux données collectées par Google</li>
          </ul>
        </section>

        <section>
          <h2>Sécurité</h2>
          <p>
            La sécurité de vos données est notre priorité :
          </p>
          <ul>
            <li>Aucune donnée personnelle n'est stockée sur nos serveurs</li>
            <li>Les connexions aux contenus externes utilisent HTTPS</li>
            <li>Le code source suit les bonnes pratiques de sécurité web</li>
          </ul>
        </section>

        <section>
          <h2>Modifications de cette politique</h2>
          <p>
            Nous pouvons mettre à jour cette politique de confidentialité occasionnellement. 
            Les modifications importantes seront signalées sur le site. Nous vous encourageons 
            à consulter régulièrement cette page.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Si vous avez des questions concernant cette politique de confidentialité 
            ou nos pratiques de protection des données, n'hésitez pas à nous contacter 
            via les canaux disponibles sur notre page 
            <button className="inline-link" onClick={() => window.location.hash = 'about'}>
              À propos
            </button>.
          </p>
        </section>

        <p className="last-updated">
          <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
        </p>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
